import { useEffect } from "react";
import { useRouterState } from "@tanstack/react-router";

type LenisLike = { scrollTo: (target: number, opts?: { immediate?: boolean }) => void };

export function ScrollToTop() {
  const pathname = useRouterState({ select: (s) => s.location.pathname });
  const hash = useRouterState({ select: (s) => s.location.hash });

  useEffect(() => {
    if (typeof window === "undefined") return;
    // Respektera anchor-länkar (#section) — scrolla bara upp om det inte finns hash.
    if (hash) return;

    const scrollTop = () => {
      const lenis = (window as unknown as { __lenis?: LenisLike }).__lenis;
      if (lenis && typeof lenis.scrollTo === "function") {
        lenis.scrollTo(0, { immediate: true });
      }
      window.scrollTo({ top: 0, left: 0, behavior: "auto" });
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;
    };

    scrollTop();
    // Kör en gång till efter att layouten satt sig (bilder/sticky/lazy-mounts).
    const r1 = requestAnimationFrame(scrollTop);
    const t = window.setTimeout(scrollTop, 50);
    return () => {
      cancelAnimationFrame(r1);
      window.clearTimeout(t);
    };
  }, [pathname, hash]);

  return null;
}
